module.exports = __webpack_public_path__ + "static/media/PursePower_Logo_003.e07bcdee.jpg";